import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  CircularProgress
} from '@mui/material';
import { useEffect } from 'react';
import { trackAnalyticsEvent } from '../../../../utils/clevertap';
import { useSelector } from 'react-redux';

const ConfirmDeleteModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  isNominee = false
}) => {
  const userData = useSelector(state => state.user?.userData);

  // Track modal load event when modal opens
  useEffect(() => {
    if (open) {
      if (isNominee) {
        trackAnalyticsEvent('BENEFICIARY_DELETE_NOMINEE_MODAL_LOAD', {
          manufacturer_id: userData?.manufacturer_id || '',
          modal_type: 'delete_nominee'
        });
      } else {
        trackAnalyticsEvent('BENEFICIARY_DELETE_BENEFICIARY_MODAL_LOAD', {
          manufacturer_id: userData?.manufacturer_id || '',
          modal_type: 'delete_beneficiary'
        });
      }
    }
  }, [open, isNominee, userData?.manufacturer_id]);

  const handleCancelClick = () => {
    // Track modal close event
    if (isNominee) {
      trackAnalyticsEvent('BENEFICIARY_DELETE_NOMINEE_MODAL_CLOSE', {
        manufacturer_id: userData?.manufacturer_id || '',
        modal_type: 'delete_nominee',
        action: 'cancel'
      });
    } else {
      trackAnalyticsEvent('BENEFICIARY_DELETE_BENEFICIARY_MODAL_CLOSE', {
        manufacturer_id: userData?.manufacturer_id || '',
        modal_type: 'delete_beneficiary',
        action: 'cancel'
      });
    }
    
    trackAnalyticsEvent('BENEFICIARY_DELETE_CANCEL_CLICK', {
      manufacturer_id: userData?.manufacturer_id || '',
      delete_type: isNominee ? 'nominee' : 'beneficiary',
      action: 'cancel'
    });
    onClose();
  };

  const handleDeleteClick = () => {
    if (isNominee) {
      trackAnalyticsEvent('BENEFICIARY_DELETE_NOMINEE_MODAL_CONFIRM_CLICK', {
        manufacturer_id: userData?.manufacturer_id || '',
        action: 'confirm_delete_nominee'
      });
    } else {
      trackAnalyticsEvent('BENEFICIARY_DELETE_BENEFICIARY_MODAL_CONFIRM_CLICK', {
        manufacturer_id: userData?.manufacturer_id || '',
        action: 'confirm_delete_beneficiary'
      });
      
      trackAnalyticsEvent('BENEFICIARY_DELETE_CONFIRM_CLICK', {
        manufacturer_id: userData?.manufacturer_id || '',
        delete_type: 'beneficiary',
        action: 'confirm_delete'
      });
    }
    onConfirm();
  };
  return (
    <Dialog open={open} onClose={onClose}
        PaperProps={{
            sx: { borderRadius: 3, textAlign: 'center',  width: 400 }
        }}
    >
      <DialogTitle>Delete {isNominee ? 'nominee' : 'beneficiary'} details</DialogTitle>
      <DialogContent sx={{ p: 2, }}>
        <Typography>
          Are you sure you want to delete this {isNominee ? 'nominee' : 'beneficiary'} details? 
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between', padding: '16px' , display: 'flex'}}>
        <Button variant='outlined' onClick={handleCancelClick} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleDeleteClick}
          color="primary"
          variant="contained"
          disabled={loading}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : 'Delete'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
